module.exports = __webpack_public_path__ + "media/images/nl/upload-dashboard-a0b059ff9761d979e7bef02df5b3e000.png";